<template>
    <section class="tool-holder">
        <div class="tool-container">
            <div class="tool__question-holder">
                <h3 class="tool__subtitle">{{ question.number }}</h3>
                <h2 class="tool__title">{{ question.title }}</h2>
                <div class="tool__text-holder" v-if="question.text">
                    <p class="tool__text">{{ question.text }}</p>
                </div>
            </div>
            <div class="tool__answer-holder tool__answer-holder--column">
                <div class="tool__image-holder" :class="{ 'tool__image-holder--vertical' : question.slug === 'spouwmuurisolatie' }">
                    <component v-if="showStill" :is="question.slug"></component>
                </div>
                <div v-if="question.slug === 'verwarmingssysteem'" class="tool__answer-holder tool__answer-holder--center radio-button-container">
                    <div v-for="(answer, index) in question.answers" :key="question.slug + index" class="radio-button-holder radio-button-holder--boxed radio-button-holder--double" :class="{ 'success' : answers[0] === answer.text }" @click="addToStore(answer.text)">
                        <input
                            type="radio"
                            :id="answer.text + index"
                            :name="question.slug"
                            :ref="answer.text"
                            :checked="answers[0] === answer.text"
                        />
                        <label :for="answer.text + index">{{ answer.text }}</label>
                    </div>
                </div>
                <div v-else class="radio-button__yes-no">
                    <div v-for="(answer, index) in question.answers" :key="question.slug + index" class="radio-button-holder radio-button-holder--boxed" :class="{ 'success' : answers[0] === answer.text }" @click="addToStore(answer.text)">
                        <input
                            type="radio"
                            :id="answer.text + index"
                            :name="question.slug"
                            :ref="answer.text"
                            :checked="answers[0] === answer.text"
                        />
                        <label :for="answer.text + index">{{ answer.text }}</label>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import lottie from 'lottie-web';

import store from '../../store/store';

// Images
import dakIsolatie from '../icons/dak-isolatie';
import hrGlas from '../icons/hr-glas';
import kelderIsolatie from '../icons/kelder-isolatie';
import kruimpruimteIsolatie from '../icons/kruimpruimte-isolatie';
import spouwMuurIsolatie from '../icons/spouw-muur-isolatie';
import ventilatie from '../icons/ventilatie';
import vloerIsolatie from '../icons/vloer-isolatie';
import zolderIsolatie from '../icons/zolder-isolatie';
import zolderVerwarming from '../icons/zolder-verwarming';
import zonnepanelen from '../icons/zonnepanelen';

export default {
    props: {
        question: {
            type: Object
        }
    },

    components: {
        'dakisolatie': dakIsolatie,
        'hr-glas': hrGlas,
        'kelderisolatie': kelderIsolatie,
        'kruipruimteisolatie': kruimpruimteIsolatie,
        'spouwmuurisolatie': spouwMuurIsolatie,
        ventilatie,
        'vloerisolatie': vloerIsolatie,
        'zolderisolatie': zolderIsolatie,
        'zolderverwarming': zolderVerwarming,
        zonnepanelen,
    },

    data() {
        return {
            store,
            answers: null,
            showStill: false,
        }
    },

    created() {
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;
    },

    mounted() {
        this.getIcon();
    },

    watch: {
        question() {
            this.getIcon();
        }
    },

    methods: {
        addToStore(value) {
            const radio = this.$refs[value][0];
            radio.click();
            this.answers = [value];

            if (this.question.slug === 'ventilatie' && value.toLowerCase() === 'ja') {
                this.store.questionInfo[this.store.currentQuestionIndex].showSideQuestions = true;
            }

            if (this.question.isSideQuestion) {
                this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] = this.answers;
                return;
            }

            this.store.questionAnswers[this.store.currentQuestionIndex].answers = this.answers;
        },

        runAnimation(icon) {
            const holder = document.querySelector('.tool__image-holder');
            const hasLoop = this.question.slug === 'ventilatie' || this.question.slug === 'zolderverwarming' ? true : false;

            this.removeIconAnimation(holder);

            if (holder && icon) {
                this.logoAnimation = lottie.loadAnimation({
                    container: holder,
                    renderer: 'svg',
                    loop: hasLoop,
                    autoplay: true,
                    animationData: icon,
                    rendererSettings: {
                        progressiveLoad: false
                    }
                });
            }
        },

        getIcon() {
            try {
                const icon = require(`../../animation/${this.question.slug}`) || null;
                if (icon) {
                    this.showStill = false;
                    this.runAnimation(icon);
                }
            } catch {
                const holder = document.querySelector('.tool__image-holder');
                this.removeIconAnimation(holder);

                const still = this.$options.components[this.question.slug];

                if (!still) {
                    this.showStill = false;
                    return;
                }

                this.showStill = true;
            }
        },

        removeIconAnimation(holder) {
            if (holder.children[0]) {
                holder.children[0].remove();
            }
        }
    },

    updated() {
        // Reset answers for when there are multiple radio questions after each other. This will prevent the template to have a success class on the fields when the user hasn't selected anything
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;
    }
}
</script>
